export default __webpack_public_path__ + "static/media/Subtract.374c0605.svg";